window.theme.scrollTo = (elementTop) => {
  const {stickyHeaderHeight} = window.theme.readHeights();

  window.scrollTo({
    top: elementTop + window.scrollY - stickyHeaderHeight,
    left: 0,
    behavior: 'smooth',
  });
};
